  <div class="loading" [hidden]="!(loaderService.isLoading | async) && !(loaderService.forceDisplay | async)"></div>
<div *ngIf="loadApp" class="app-container">
  <app-header *ngIf="headerFooter"></app-header>

  <div [ngClass]="{ 'view-container container headerDisplayed': headerFooter, 'view-container container headerNotDisplayed': !headerFooter }" >
    <!--
      // On désactive la publicité sur toutes les pages pour le moment pour ne les mettre que sur la page d'accueil et le Catalogue
      <app-advertisement></app-advertisement>-->

    <router-outlet></router-outlet>
  </div>
  <!--
    Custom modal setup
    It will be dynamically loaded with modalService and domService
  -->
  <div id="modal-container" class="modal"></div>

  <app-footer *ngIf="contextService.context.companyCode"></app-footer>
</div>

<div *ngIf="!loadApp">
  <div class="view-container container">
    <app-maintenance></app-maintenance>
  </div>
</div>
